module.exports = __webpack_public_path__ + "assets/img/zichanfang.101d96ae.png";